import { useEffect, useState } from 'react';

import { OverviewData } from '../../../../interfaces/entity-dashboard/OverviewData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';

type UseOverviewDataReturn = {
  overviewData: OverviewData | null;
};

type UseOverviewDataProps = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

export const useOverviewData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseOverviewDataProps): UseOverviewDataReturn => {
  const [overviewData, setOverviewData] = useState<OverviewData | null>(null);

  const fetchOverviewData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getOverviewData({
      ...dateRange,
      solutionType: solutionTypeFilter,
    });

    setOverviewData(data);
  };

  useEffect(() => {
    fetchOverviewData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { overviewData };
};
